import $ from 'jquery';
import 'parsleyjs';

const options = {
    successClass: 'has-success',
    errorClass: 'has-error',
    classHandler(field) {
        return field.$element.parents('.form__field');
    },
    errorsWrapper: '<ul class="form__errors"></ul>',
};

window.Parsley.on('form:validated', (form) => {
    $('html, body').animate({
        scrollTop: form.$element.offset().top,
    }, 150);
});

const forms = Array.from(document.querySelectorAll('.js-form-validate'));
forms.forEach(element => $(element).parsley(options));



// WEBPACK FOOTER //
// ./app/scripts/components/forms.js